// Calque de coloration des mentions [entre crochets] dans la réponse générée -- un <textarea>
// natif ne pouvant pas colorer une partie de son propre texte, on superpose un calque en lecture
// seule (#reply-text-highlight) derrière le textarea rendu transparent.
export function escapeHtml(text: string): string {
  return text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

export function renderReplyHighlight(): void {
  const textElement = document.getElementById("reply-text") as HTMLTextAreaElement;
  const highlightElement = document.getElementById("reply-text-highlight");
  const highlighted = escapeHtml(textElement.value).replace(/\[([^[\]]+)\]/g, "<mark>[$1]</mark>");
  // Espace final pour que le calque conserve la même hauteur de ligne qu'un textarea se terminant par un retour à la ligne.
  highlightElement.innerHTML = highlighted + (textElement.value.endsWith("\n") ? " " : "");
  syncHighlightLayout();
  // Après une édition (regénération, restauration du cache, frappe qui fait défiler pour garder
  // le curseur visible), le navigateur ajuste le scrollTop du textarea *après* la repasse de mise
  // en page qui suit cet appel -- un sync synchrone ici lit donc parfois l'ancien scrollTop et le
  // calque reste décalé d'une ligne ou deux par rapport au vrai texte (invisible sauf sélection).
  // On resynchronise une fois la mise en page faite pour rattraper ce cas.
  requestAnimationFrame(syncHighlightLayout);
}

// La scrollbar du textarea (présente seulement quand le texte déborde) réduit la largeur de ses
// lignes, pas celles du calque qui n'en a pas : sans compensation, les retours à la ligne diffèrent
// et le texte sélectionnable ne coïncide plus avec le texte affiché. On reporte donc sa largeur
// réelle (variable selon le moteur) dans le padding droit du calque.
function syncHighlightLayout(): void {
  const textElement = document.getElementById("reply-text") as HTMLTextAreaElement;
  const highlightElement = document.getElementById("reply-text-highlight");
  const scrollbarWidth = textElement.offsetWidth - textElement.clientWidth - 2 * textElement.clientLeft;
  const basePadding = parseFloat(getComputedStyle(textElement).paddingRight) || 0;
  highlightElement.style.paddingRight = `${basePadding + Math.max(0, scrollbarWidth)}px`;
  syncHighlightScroll();
}

function syncHighlightScroll(): void {
  const textElement = document.getElementById("reply-text") as HTMLTextAreaElement;
  const highlightElement = document.getElementById("reply-text-highlight");
  highlightElement.scrollTop = textElement.scrollTop;
}

export function bindReplyTextHighlight(): void {
  const textElement = document.getElementById("reply-text") as HTMLTextAreaElement;
  const highlightElement = document.getElementById("reply-text-highlight");
  const wrapElement = document.getElementById("reply-text-wrap");

  textElement.addEventListener("input", renderReplyHighlight);
  textElement.addEventListener("scroll", syncHighlightScroll);
  textElement.addEventListener("focus", () => wrapElement.classList.add("is-focused"));
  textElement.addEventListener("blur", () => wrapElement.classList.remove("is-focused"));

  if (typeof ResizeObserver !== "undefined") {
    new ResizeObserver(() => {
      highlightElement.style.height = `${textElement.offsetHeight}px`;
      highlightElement.style.width = `${textElement.offsetWidth}px`;
      // Redimensionner (poignée de resize CSS) peut révéler/masquer du contenu et donc changer le
      // scrollTop du textarea (et l'apparition de sa scrollbar) sans forcément déclencher son
      // événement "scroll" -- resynchroniser ici.
      syncHighlightLayout();
    }).observe(textElement);
  }

  renderReplyHighlight();
}

// onBlur est injecté (persistReplyCache vit dans le moteur de génération, outlook.ts) pour ne pas
// faire dépendre ce module du cache de réponse.
export function bindReplyTextBlur(onBlur: () => void): void {
  const textElement = document.getElementById("reply-text") as HTMLTextAreaElement;
  textElement.addEventListener("blur", onBlur);
}
